var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',_vm._b({attrs:{"href":_vm.item.link,"target":"_blank"}},'v-btn',_vm.props,false),[_vm._v("\n  "+_vm._s(_vm.item.name)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }